import { render, staticRenderFns } from "./EditReadAloud.vue?vue&type=template&id=aca413d4&scoped=true&"
import script from "./EditReadAloud.vue?vue&type=script&lang=js&"
export * from "./EditReadAloud.vue?vue&type=script&lang=js&"
import style0 from "./EditReadAloud.vue?vue&type=style&index=0&id=aca413d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca413d4",
  null
  
)

export default component.exports